"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62571],{

/***/ 92124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ DAY_TRADE_ACTIVATION_SELECTED; },
/* harmony export */   "B": function() { return /* binding */ STOCK_SELECTED; },
/* harmony export */   "BY": function() { return /* binding */ DAY_TRADE_ORDER_DETAIL_SELECTED; },
/* harmony export */   "CV": function() { return /* binding */ DAY_TRADE_SPLIT_ORDER_SELECTED; },
/* harmony export */   "D1": function() { return /* binding */ DAY_TRADE_ALERT_AFTER_MARKET_VIEWED; },
/* harmony export */   "DQ": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUCCESS_VIEWED; },
/* harmony export */   "Dn": function() { return /* binding */ EXERCISE_ORDER_CONFIRMED; },
/* harmony export */   "E": function() { return /* binding */ AMEND_ORDER_CONFIRMED; },
/* harmony export */   "G2": function() { return /* binding */ DAY_TRADE_SET_VISIBLE_BALANCE; },
/* harmony export */   "GK": function() { return /* binding */ DAY_TRADE_STOCK_LIST_VIEWED; },
/* harmony export */   "Go": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUCCESS_SELECTED; },
/* harmony export */   "HA": function() { return /* binding */ BUY_ORDER_VIEWED; },
/* harmony export */   "HM": function() { return /* binding */ AUTO_BUY_ACTION; },
/* harmony export */   "Hb": function() { return /* binding */ AMEND_ORDER_PREVIEWED; },
/* harmony export */   "Hd": function() { return /* binding */ SECURITIES_TRADING_PIN_VIEWED; },
/* harmony export */   "Hm": function() { return /* binding */ BUY_ORDER_RECEIVED; },
/* harmony export */   "II": function() { return /* binding */ SECURITIES_TRADING_PIN_SUBMITTED; },
/* harmony export */   "IU": function() { return /* binding */ BUY_ERROR_PAGE; },
/* harmony export */   "J1": function() { return /* binding */ PORTFOLIO_VIEW_CHART_SELECTED; },
/* harmony export */   "JW": function() { return /* binding */ PORTFOLIO_COMPANY_SELL_STOCK_SELECTED; },
/* harmony export */   "L7": function() { return /* binding */ DAY_TRADE_LEVERAGE_SELECTED; },
/* harmony export */   "L9": function() { return /* binding */ BUY_ORDER_PREVIEWED; },
/* harmony export */   "LD": function() { return /* binding */ SELL_ORDER_CONFIRMED_SUCCESS; },
/* harmony export */   "Le": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_SELECTED; },
/* harmony export */   "Nq": function() { return /* binding */ EXERCISE_SELECTED; },
/* harmony export */   "O9": function() { return /* binding */ AMEND_ORDER_DONE; },
/* harmony export */   "Oc": function() { return /* binding */ SECURITIES_ORDER_TAB_SELECTED; },
/* harmony export */   "TC": function() { return /* binding */ DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED; },
/* harmony export */   "Tf": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_VIEWED; },
/* harmony export */   "Vm": function() { return /* binding */ EXERCISE_ERROR_PAGE; },
/* harmony export */   "YB": function() { return /* binding */ DAY_TRADE_ORDER_TYPE_SELECTED; },
/* harmony export */   "YM": function() { return /* binding */ DAY_TRADE_STOCK_SORT_VIEWED; },
/* harmony export */   "YS": function() { return /* binding */ SECURITIES_AUTO_ORDER_OPTIONS_VIEWED; },
/* harmony export */   "Yu": function() { return /* binding */ DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED; },
/* harmony export */   "ZF": function() { return /* binding */ SELL_ORDER_CONFIRMED; },
/* harmony export */   "ZN": function() { return /* binding */ AMEND_ORDER_RECEIVED; },
/* harmony export */   "Zy": function() { return /* binding */ DAY_TRADE_SORT_APPLIED; },
/* harmony export */   "_O": function() { return /* binding */ PORTFOLIO_BUY_MORE_SELECTED; },
/* harmony export */   "_e": function() { return /* binding */ EXCHANGE_FEE_VIEWED; },
/* harmony export */   "_g": function() { return /* binding */ PORTFOLIO_EXERCISE_CLICKED; },
/* harmony export */   "a": function() { return /* binding */ EXERCISE_ORDER_CANCELED; },
/* harmony export */   "bK": function() { return /* binding */ DAY_TRADE_DEBT_RATIO_MODAL_VIEWED; },
/* harmony export */   "bt": function() { return /* binding */ DAY_TRADE_ACTION; },
/* harmony export */   "cG": function() { return /* binding */ AMEND_ORDER_PLACED; },
/* harmony export */   "cc": function() { return /* binding */ DAY_TRADE_SORT_SELECTED; },
/* harmony export */   "dR": function() { return /* binding */ CLEVERTAP_EVENT_NAME; },
/* harmony export */   "dT": function() { return /* binding */ SELL_ORDER_CANCELED; },
/* harmony export */   "dW": function() { return /* binding */ EXERCISE_VIEWED; },
/* harmony export */   "dz": function() { return /* binding */ ORDER_VIEWED; },
/* harmony export */   "ee": function() { return /* binding */ BUY_ORDER_CONFIRMED; },
/* harmony export */   "ef": function() { return /* binding */ PORTFOLIO_SET_PRICE_ALERT_SELECTED; },
/* harmony export */   "fR": function() { return /* binding */ ORDER_DETAIL_CANCEL_ORDER_CONFIRMED; },
/* harmony export */   "fg": function() { return /* binding */ ORDER_DETAIL_AMEND_SELECTED; },
/* harmony export */   "g1": function() { return /* binding */ BUY_ORDER_DONE; },
/* harmony export */   "gE": function() { return /* binding */ SELL_ORDER_VIEWED; },
/* harmony export */   "gW": function() { return /* binding */ BUY_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "gg": function() { return /* binding */ BUY_ORDER_PLACED; },
/* harmony export */   "hG": function() { return /* binding */ DAY_TRADE_TNC_VIEWED; },
/* harmony export */   "iW": function() { return /* binding */ AMEND_ORDER_CANCELED; },
/* harmony export */   "jG": function() { return /* binding */ EXERCISE_ORDER_PREVIEWED; },
/* harmony export */   "jY": function() { return /* binding */ DAY_TRADE_ACTIVATION_VIEWED; },
/* harmony export */   "jr": function() { return /* binding */ CHANGE_STOCK_VIEWED; },
/* harmony export */   "kC": function() { return /* binding */ PORTFOLIO_STOCK_DETAIL_VIEWED; },
/* harmony export */   "lE": function() { return /* binding */ BUY_ORDER_CANCELED; },
/* harmony export */   "lK": function() { return /* binding */ AMEND_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "le": function() { return /* binding */ PORTFOLIO_DETAIL_EXERCISE_SELECTED; },
/* harmony export */   "mX": function() { return /* binding */ DAY_TRADE_ACTIVATION_SUBMITTED; },
/* harmony export */   "n2": function() { return /* binding */ SELL_ORDER_RECEIVED; },
/* harmony export */   "nc": function() { return /* binding */ DAY_TRADE_ALERT_DEBT_RATIO_VIEWED; },
/* harmony export */   "p3": function() { return /* binding */ BUY_ORDER_CONFIRMED_SUCCESS; },
/* harmony export */   "q7": function() { return /* binding */ SELL_ORDER_PREVIEWED; },
/* harmony export */   "sR": function() { return /* binding */ SELL_ORDER_QUANTITY_ADJUSTED; },
/* harmony export */   "tA": function() { return /* binding */ PORTFOLIO_VIEWED; },
/* harmony export */   "tI": function() { return /* binding */ EXCHANGE_FEE_SELECTED; },
/* harmony export */   "v9": function() { return /* binding */ ORDER_DETAIL_VIEWED; },
/* harmony export */   "vc": function() { return /* binding */ SELL_ORDER_PLACED; },
/* harmony export */   "vf": function() { return /* binding */ PORTFOLIO_SELL_STOCK_SELECTED; },
/* harmony export */   "wK": function() { return /* binding */ DAY_TRADE_ACTIVATION_DISMISSED; },
/* harmony export */   "xc": function() { return /* binding */ SELL_ORDER_DONE; },
/* harmony export */   "z8": function() { return /* binding */ AMEND_ORDER_VIEWED; },
/* harmony export */   "zF": function() { return /* binding */ PORTFOLIO_ORDER_VIEWED; },
/* harmony export */   "zW": function() { return /* binding */ DAY_TRADE_LEVERAGE_OPTION_VIEWED; },
/* harmony export */   "zt": function() { return /* binding */ DAY_TRADE_DEBT_RATIO_CHIP_SELECTED; }
/* harmony export */ });
/* unused harmony exports TRANSACTION_ORDER_FAILED, TRANSACTION_ORDER_FAILED_CONFIRMED, TRANSACTION_ORDER_ALERT, BUY_STOCK_CONTINUE */
var CLEVERTAP_EVENT_NAME = {
    SIDE_MENU: "side_menu_action",
    HEADER_MENU: "header_menu_action",
    COMPANY_MENU: "company_action"
};
// List of stockbit securities clevertap event name
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
/// //////// Cancel Order and Amend Event ///////////
var ORDER_DETAIL_CANCEL_ORDER_SELECTED = "Order Detail Cancel Order Selected";
var ORDER_DETAIL_CANCEL_ORDER_VIEWED = "Order Detail Cancel Order Viewed";
var ORDER_DETAIL_CANCEL_ORDER_CONFIRMED = "Order Detail Cancel Order Confirmed";
var ORDER_DETAIL_AMEND_SELECTED = "Order Detail Amend Selected";
var AMEND_ORDER_VIEWED = "Amend Order Viewed";
var AMEND_ORDER_QUANTITY_ADJUSTED = "Amend Order Quantity Adjusted";
var AMEND_ORDER_PLACED = "Amend Order Placed";
var AMEND_ORDER_PREVIEWED = "Amend Order Previewed";
var AMEND_ORDER_CANCELED = "Amend Order Canceled";
var AMEND_ORDER_CONFIRMED = "Amend Order Confirmed";
var AMEND_ORDER_RECEIVED = "Amend Order Received";
var AMEND_ORDER_DONE = "Amend Order Done";
/// //////// Buy Order Event ///////////
var BUY_ORDER_QUANTITY_ADJUSTED = "Buy Order Quantity Adjusted";
var BUY_ORDER_PLACED = "Buy Order Placed";
var BUY_ORDER_PREVIEWED = "Buy Order Previewed";
var BUY_ORDER_VIEWED = "Buy Order Viewed";
var BUY_ORDER_CANCELED = "Buy Order Canceled";
var BUY_ORDER_CONFIRMED = "Buy Order Confirmed";
var BUY_ORDER_RECEIVED = "Buy Order Received";
var BUY_ORDER_DONE = "Buy Order Done";
var BUY_ERROR_PAGE = "Buy Error Page";
var CHANGE_STOCK_VIEWED = "Change Stock Viewed";
var PORTFOLIO_BUY_MORE_SELECTED = "Portfolio Buy More Selected";
var BUY_ORDER_CONFIRMED_SUCCESS = "Success Buy Order Confirmed";
/// //////// Sell Order Event ///////////
var SELL_ORDER_QUANTITY_ADJUSTED = "Sell Order Quantity Adjusted";
var SELL_ORDER_PLACED = "Sell Order Placed";
var SELL_ORDER_PREVIEWED = "Sell Order Previewed";
var SELL_ORDER_VIEWED = "Sell Order Viewed";
var SELL_ORDER_CANCELED = "Sell Order Canceled";
var SELL_ORDER_CONFIRMED = "Sell Order Confirmed";
var SELL_ORDER_RECEIVED = "Sell Order Received";
var SELL_ORDER_DONE = "Sell Order Done";
var SELL_ORDER_CONFIRMED_SUCCESS = "Success Sell Order Confirmed";
/// //////// Exchange Fee Event ///////////
var EXCHANGE_FEE_SELECTED = "Exchange Fee Selected";
var EXCHANGE_FEE_VIEWED = "Exchange Fee Viewed";
/// //////// Portfolio Event ///////////
var PORTFOLIO_VIEWED = "Portfolio Viewed";
var PORTFOLIO_ORDER_VIEWED = "Portfolio Order Viewed";
var PORTFOLIO_SELL_STOCK_SELECTED = "Portfolio Sell Stock Selected";
var PORTFOLIO_COMPANY_SELL_STOCK_SELECTED = "Company Sell Stock Selected";
var PORTFOLIO_STOCK_DETAIL_VIEWED = "Portfolio Stock Detail Viewed";
/// //////// Order List Page Event ///////////
var ORDER_VIEWED = "Order viewed";
var ORDER_DETAIL_VIEWED = "Order Detail Viewed";
var STOCK_SELECTED = "Stock Selected";
/// //////// Order Exercise Event ///////////
var PORTFOLIO_EXERCISE_CLICKED = "Portfolio Exercise Clicked";
var PORTFOLIO_DETAIL_EXERCISE_SELECTED = "Portfolio Detail Exercise Selected";
var EXERCISE_VIEWED = "Exercise Viewed";
var EXERCISE_SELECTED = "Exercise Selected";
var EXERCISE_ERROR_PAGE = "Exercise Error Page";
var EXERCISE_ORDER_PREVIEWED = "Exercise Order Previewed";
var EXERCISE_ORDER_CONFIRMED = "Exercise Order Confirmed";
var EXERCISE_ORDER_CANCELED = "Exercise Order Canceled";
var TRANSACTION_ORDER_FAILED = "Transaction Order Failed";
var TRANSACTION_ORDER_FAILED_CONFIRMED = "Transaction Order Failed Confirmed";
var TRANSACTION_ORDER_ALERT = "Transaction Order Alert";
var BUY_STOCK_CONTINUE = "Buy Stock Continue";
/// //////// Chart Event ///////////
var PORTFOLIO_VIEW_CHART_SELECTED = "Portfolio View Chart Selected";
var PORTFOLIO_SET_PRICE_ALERT_SELECTED = "Portfolio Set Price Alert Selected";
/// //////// Day Trade Event ///////////
var DAY_TRADE_ACTION = "Day Trade Action";
var AUTO_BUY_ACTION = "Auto Buy Action";
var DAY_TRADE_ACTIVATION_VIEWED = "Day Trade Activation Viewed";
var DAY_TRADE_TNC_VIEWED = "Tnc Day Trade Viewed";
var DAY_TRADE_ACTIVATION_SUCCESS_VIEWED = "Success Activated Day Trade Viewed";
var DAY_TRADE_ACTIVATION_SELECTED = "Day Trade Activated Now Selected";
var DAY_TRADE_ACTIVATION_DISMISSED = "Day Trade Activated Later Selected";
var DAY_TRADE_ACTIVATION_SUBMITTED = "TnC Day Trade Lanjut Selected";
var DAY_TRADE_ACTIVATION_SUCCESS_SELECTED = "Day Trade Success Activated Selected";
var DAY_TRADE_LEVERAGE_OPTION_VIEWED = "Balance Setting Viewed";
var DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED = "Day Trade Aktifkan Selected";
var DAY_TRADE_ALERT_AFTER_MARKET_VIEWED = "Alert After Hour Day Trade Viewed";
var DAY_TRADE_ALERT_DEBT_RATIO_VIEWED = "Alert Force Sell Day Trade Viewed";
var DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED = "Alert Force Sell Day Trade Selected";
var DAY_TRADE_DEBT_RATIO_CHIP_SELECTED = "Debt Ratio Selected";
var DAY_TRADE_DEBT_RATIO_MODAL_VIEWED = "Debt Ratio Viewed";
var DAY_TRADE_STOCK_LIST_VIEWED = "Day Trade List Viewed";
var DAY_TRADE_STOCK_SORT_VIEWED = "Day Trade Sort By Viewed";
var DAY_TRADE_LEVERAGE_SELECTED = "Set Leverage Selected";
var DAY_TRADE_SORT_SELECTED = "Sort By Day Trade Selected";
var DAY_TRADE_SORT_APPLIED = "Apply Sort Day Trade";
var DAY_TRADE_ORDER_TYPE_SELECTED = "Auto Buy Order Type Selected";
var DAY_TRADE_SPLIT_ORDER_SELECTED = "Split Order Toggle Selected";
var DAY_TRADE_ORDER_DETAIL_SELECTED = "Order Detail Selected";
var DAY_TRADE_SET_VISIBLE_BALANCE = "Set Visible Balance";
var SECURITIES_TRADING_PIN_VIEWED = "Trading PIN Login Page Viewed";
var SECURITIES_TRADING_PIN_SUBMITTED = "Trading PIN Loggen In";
var SECURITIES_AUTO_ORDER_OPTIONS_VIEWED = "Auto Buy Order Type Viewed";
var SECURITIES_ORDER_TAB_SELECTED = "Order Transaction Type Selected";


/***/ }),

/***/ 3683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ModalNames; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var ModalNames;
(function(ModalNames) {
    ModalNames["PORTFOLIO_ONBOARDING"] = "PORTFOLIO_ONBOARDING";
    ModalNames["PORTFOLIO_CREATE"] = "PORTFOLIO_CREATE";
    ModalNames["PORTFOLIO_CREATE_BLOCKED"] = "PORTFOLIO_CREATE_BLOCKED";
    ModalNames["PORTFOLIO_TNC"] = "PORTFOLIO_TNC";
    ModalNames["PORTFOLIO_SUCCESS"] = "PORTFOLIO_SUCCESS";
    ModalNames["PORTFOLIO_RENAME"] = "PORTFOLIO_RENAME";
    ModalNames["TRANSFER_SELECT"] = "TRASNFER_SELECT";
    ModalNames["TRANSFER_CASH"] = "TRANSFER_CASH";
    ModalNames["TRANSFER_CASH_CONFIRM"] = "TRANSFER_CASH_CONFIRM";
    ModalNames["TRANSFER_CASH_SUCCESS"] = "TRANSFER_CASH_SUCCESS";
    ModalNames["TRANSFER_CASH_BALANCE_REVIEW"] = "TRANSFER_CASH_BALANCE_REVIEW";
    ModalNames["TRANSFER_STOCK"] = "TRANSFER_STOCK";
    ModalNames["TRANSFER_STOCK_CONFIRM"] = "TRANSFER";
    ModalNames["TRANSFER_STOCK_SUCCESS"] = "TRANSFER_STOCK_SUCCESS";
})(ModalNames || (ModalNames = {}));
var useModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        activeModal: null,
        openModal: function(modalName) {
            return set({
                activeModal: modalName
            });
        },
        closeModal: function() {
            return set({
                activeModal: null
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useModalStore);


/***/ }),

/***/ 9657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ balanceLabel; },
/* harmony export */   "IY": function() { return /* binding */ expiryId; },
/* harmony export */   "Me": function() { return /* binding */ expiryOptions; },
/* harmony export */   "Ud": function() { return /* binding */ orderTypeOptions; },
/* harmony export */   "nz": function() { return /* binding */ smartOrderText; },
/* harmony export */   "wc": function() { return /* binding */ expiryTypeById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);


var balanceLabel = {
    cashOnHand: "Cash On Hand",
    tradingBalance: "Trading Balance",
    tradingLimit: "Trading Limit",
    dayTrade: "Buying Power"
};
var _obj;
var smartOrderText = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.AutoBuy */ .H1.AutoBuy, "Auto Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.StopLoss */ .H1.StopLoss, "Stop Loss"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.TakeProfit */ .H1.TakeProfit, "Take Profit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderCode.LimitIfTouched */ .H1.LimitIfTouched, "Limit If Touched"), _obj);
var _obj1;
var orderTypeOptions = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .TransactionType.Buy */ .iU.Buy, {
    "Limit Order": "Limit Order",
    AutoBuy: "Limit If Touched",
    "Auto Buy": "Limit If Touched",
    Market: "Market Order"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .TransactionType.Sell */ .iU.Sell, {
    "Limit Order": "Limit Order",
    StopLoss: smartOrderText.SL,
    TakeProfit: smartOrderText.TP,
    Market: "Market Order",
    "Trailing Stop": "Trailing Stop"
}), _obj1);
var _obj2;
var expiryOptions = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good For Day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good Till Cancelled"), _obj2);
var _obj3;
var expiryId = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay, 0), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, 1), _obj3);
var expiryTypeById = {
    0: _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay,
    1: _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled
};


/***/ }),

/***/ 71158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useSecuritiesCredentialStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/config/requestRefreshTrading.tsx
var requestRefreshTrading = __webpack_require__(47050);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/authSecurities.ts




var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var authSecurities_requestRefreshTrading = (0,requestRefreshTrading/* default */.Z)();
var postSwitchVirtual = function() {
    return defaultInstance.post("virtualtrading/account/activate");
};
var postAuthRefresh = function(refreshToken) {
    return authSecurities_requestRefreshTrading.post("".concat((0,utils/* isRedirectToNewCore */.JI)() ? api/* API_TRADING_URL_V2 */.cu : api/* API_TRADING_URL */.Cb, "/auth/refresh"), {
        refresh_token: refreshToken
    });
};

// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/multi-porto.ts
var multi_porto = __webpack_require__(13083);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts














var initialState = {
    accountType: securitiesLocalStorage/* default.getTradingAccountType */.Z.getTradingAccountType(),
    accessToken: securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesAccessToken,
    refreshToken: securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesRefreshToken,
    type: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType,
    accountNumber: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountNumber,
    mainAccountNumber: securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().mainAccountNumber
};
var useSecuritiesCredentialStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        resetStore: function() {
            return set({
                accountType: null,
                accessToken: null,
                refreshToken: null,
                type: null,
                accountNumber: null,
                mainAccountNumber: null
            });
        },
        switchAccountType: function(accountType) {
            return set({
                accountType: accountType
            });
        },
        loadLoginReal: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pin) {
                var ref, ref1, loginTokenRes, ref2, ref3, loginToken, target, validatePinRes, ref4, ref5, data, error_type, message, ref6, accessToken, refreshToken, account, main_account, ref7, type, number, ref8, ref9, ref10, ref11;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return securities/* default.getAuthToken */.Z.getAuthToken();
                        case 4:
                            loginTokenRes = _ctx.sent;
                            ;
                            ref3 = (ref2 = loginTokenRes === null || loginTokenRes === void 0 ? void 0 : (ref = loginTokenRes.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref2 !== void 0 ? ref2 : {}, loginToken = ref3.token, target = ref3.target;
                            if (loginToken) {
                                _ctx.next = 9;
                                break;
                            }
                            throw Error("Get Login Token failed", {
                                cause: {
                                    type: "GET_AUTH_TOKEN"
                                }
                            });
                        case 9:
                            (0,utils/* setTargetAPI */.yM)(target);
                            _ctx.next = 12;
                            return securities/* default.postAuthPIN */.Z.postAuthPIN(loginToken, pin);
                        case 12:
                            validatePinRes = _ctx.sent;
                            ;
                            ref5 = (ref4 = validatePinRes === null || validatePinRes === void 0 ? void 0 : validatePinRes.data) !== null && ref4 !== void 0 ? ref4 : {}, data = ref5.data, error_type = ref5.error_type, message = ref5.message;
                            ref6 = data !== null && data !== void 0 ? data : {}, accessToken = ref6.access_token, refreshToken = ref6.refresh_token, account = ref6.account, main_account = ref6.main_account;
                            ref7 = account !== null && account !== void 0 ? account : {}, type = ref7.type, number = ref7.number;
                            if (!(error_type || !accessToken || !refreshToken)) {
                                _ctx.next = 19;
                                break;
                            }
                            throw Error(message || "Attemp to post Auth PIN failed", {
                                cause: {
                                    type: "POST_AUTH_PIN",
                                    error_type: error_type,
                                    message: message
                                }
                            });
                        case 19:
                            (ref1 = multiPorto/* default */.Z === null || multiPorto/* default */.Z === void 0 ? void 0 : multiPorto/* default.getState */.Z.getState()) === null || ref1 === void 0 ? void 0 : ref1.setActiveAccount(number);
                            securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                                securitiesAccessToken: accessToken,
                                securitiesRefreshToken: refreshToken
                            });
                            securitiesLocalStorage/* default.saveSecuritiesAccountInfo */.Z.saveSecuritiesAccountInfo({
                                accountType: account === null || account === void 0 ? void 0 : account.type,
                                accountNumber: account === null || account === void 0 ? void 0 : account.number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            set({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                accountType: types/* ACCOUNT_TYPE.REAL */.Q5.REAL,
                                type: type,
                                accountNumber: number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            return _ctx.abrupt("return", {
                                loginToken: loginToken,
                                target: target,
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                type: type,
                                number: number
                            });
                        case 26:
                            _ctx.prev = 26;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            (0,logger/* default */.ZP)(_ctx.t0, {
                                event: "useSecuritiesCredentialStore@loadLoginReal",
                                errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause,
                                errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref8 = _ctx.t0.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.error_type,
                                errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref10 = _ctx.t0.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.message
                            });
                            throw _ctx.t0;
                        case 31:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        26
                    ]
                ]);
            }));
            return function(pin) {
                return _ref.apply(this, arguments);
            };
        }(),
        loadLoginVirtual: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, ref, ref1, ref2, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return postSwitchVirtual();
                    case 3:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to switch to virtual failed");
                    case 6:
                        securitiesLocalStorage/* default.switchToVirtualTrading */.Z.switchToVirtualTrading();
                        set({
                            accountType: types/* ACCOUNT_TYPE.VIRTUAL */.Q5.VIRTUAL
                        });
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@loginVirtual",
                            errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error_type,
                            errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message
                        });
                        throw _ctx.t0;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        loadLogout: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, accountType, accessToken, resetStore, ref1, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), accountType = ref.accountType, accessToken = ref.accessToken, resetStore = ref.resetStore;
                        _ctx.prev = 1;
                        if (!(accountType === types/* ACCOUNT_TYPE.REAL */.Q5.REAL && accessToken)) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 6;
                        return trade/* default.logout */.Z.logout();
                    case 6:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Attempt to logout trading failed");
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@logout",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 14:
                        resetStore();
                        securitiesLocalStorage/* default.logoutTrading */.Z.logoutTrading();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        })),
        loadRefresh: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, currentRefreshToken, logout, res, _data, ref1, accessToken, refreshToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), currentRefreshToken = ref.refreshToken, logout = ref.loadLogout;
                        _ctx.prev = 1;
                        if (currentRefreshToken) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Securities refresh token does not exist");
                    case 4:
                        _ctx.next = 6;
                        return postAuthRefresh(currentRefreshToken);
                    case 6:
                        res = _ctx.sent;
                        if (!(!(res === null || res === void 0 ? void 0 : res.data) || res.data.error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Attemp to refresh token failed");
                    case 9:
                        ;
                        ref1 = (_data = res.data.data) !== null && _data !== void 0 ? _data : {}, accessToken = ref1.access_token, refreshToken = ref1.refresh_token;
                        securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                            securitiesAccessToken: accessToken,
                            securitiesRefreshToken: refreshToken
                        });
                        set({
                            accessToken: accessToken,
                            refreshToken: refreshToken
                        });
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        logout();
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "useSecuritiesCredentialStore@refresh",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                        throw _ctx.t0;
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        })),
        loadSwitchLoginReal: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(accountNumber) {
                var validatePinRes, ref, ref1, data, error_type, message, ref2, accessToken, refreshToken, account, main_account, ref3, type, number, tokenUpdateEvent, channel, ref4, ref5, ref6, ref7;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return multi_porto/* default.postSwitchAccount */.Z.postSwitchAccount(accountNumber);
                        case 3:
                            validatePinRes = _ctx.sent;
                            ;
                            ref1 = (ref = validatePinRes === null || validatePinRes === void 0 ? void 0 : validatePinRes.data) !== null && ref !== void 0 ? ref : {}, data = ref1.data, error_type = ref1.error_type, message = ref1.message;
                            ref2 = data !== null && data !== void 0 ? data : {}, accessToken = ref2.access_token, refreshToken = ref2.refresh_token, account = ref2.account, main_account = ref2.main_account;
                            ref3 = account !== null && account !== void 0 ? account : {}, type = ref3.type, number = ref3.number;
                            if (!(error_type || !accessToken || !refreshToken)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw Error(message || "Attemp to Switch Sub Account failed", {
                                cause: {
                                    type: "POST_SWITCH_SUB_ACCOUNT",
                                    error_type: error_type,
                                    message: message
                                }
                            });
                        case 10:
                            securitiesLocalStorage/* default.saveSecuritiesToken */.Z.saveSecuritiesToken({
                                securitiesAccessToken: accessToken,
                                securitiesRefreshToken: refreshToken
                            });
                            securitiesLocalStorage/* default.saveSecuritiesAccountInfo */.Z.saveSecuritiesAccountInfo({
                                accountType: account === null || account === void 0 ? void 0 : account.type,
                                accountNumber: account === null || account === void 0 ? void 0 : account.number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            tokenUpdateEvent = new CustomEvent("updateMultiPorto", {
                                detail: {
                                    number: number
                                }
                            });
                            window.dispatchEvent(tokenUpdateEvent);
                            channel = new BroadcastChannel("updateMultiPorto");
                            channel.postMessage({
                                number: number
                            });
                            set({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                accountType: types/* ACCOUNT_TYPE.REAL */.Q5.REAL,
                                type: type,
                                accountNumber: number,
                                mainAccountNumber: main_account === null || main_account === void 0 ? void 0 : main_account.number
                            });
                            return _ctx.abrupt("return", {
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                type: type,
                                number: number
                            });
                        case 20:
                            _ctx.prev = 20;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            (0,logger/* default */.ZP)(_ctx.t0, {
                                event: "useSecuritiesCredentialStore@loadLoginReal",
                                errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause,
                                errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.error_type,
                                errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message
                            });
                            throw _ctx.t0;
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        20
                    ]
                ]);
            }));
            return function(accountNumber) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ var stores_useSecuritiesCredentialStore = (useSecuritiesCredentialStore);


/***/ }),

/***/ 2078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "H1": function() { return /* binding */ SmartOrderCode; },
/* harmony export */   "PH": function() { return /* binding */ SplitOrderMethodEnum; },
/* harmony export */   "XL": function() { return /* binding */ PaymentMethod; },
/* harmony export */   "YQ": function() { return /* binding */ AmendSellOrderType; },
/* harmony export */   "ZM": function() { return /* binding */ Expiry; },
/* harmony export */   "dY": function() { return /* binding */ BuyOrderType; },
/* harmony export */   "iF": function() { return /* binding */ OrderStatus; },
/* harmony export */   "iU": function() { return /* binding */ TransactionType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "om": function() { return /* binding */ SmartOrderType; },
/* harmony export */   "qK": function() { return /* binding */ SellOrderType; }
/* harmony export */ });
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["TradingBalance"] = "TradingBalance";
    PaymentMethod["TradingLimit"] = "TradingLimit";
    PaymentMethod["DayTrade"] = "DayTrade";
})(PaymentMethod || (PaymentMethod = {}));
var BuyOrderType;
(function(BuyOrderType) {
    BuyOrderType["LimitOrder"] = "Limit Order";
    BuyOrderType["AutoBuy"] = "AutoBuy";
    BuyOrderType["Auto Buy"] = "Auto Buy";
    BuyOrderType["MarketOrder"] = "Market";
})(BuyOrderType || (BuyOrderType = {}));
var SellOrderType;
(function(SellOrderType) {
    SellOrderType["LimitOrder"] = "Limit Order";
    SellOrderType["StopLoss"] = "StopLoss";
    SellOrderType["TakeProfit"] = "TakeProfit";
    SellOrderType["MarketOrder"] = "Market";
    SellOrderType["TrailingStop"] = "Trailing Stop";
})(SellOrderType || (SellOrderType = {}));
var SmartOrderType;
(function(SmartOrderType) {
    SmartOrderType["AutoBuy"] = "AutoBuy";
    SmartOrderType["StopLoss"] = "StopLoss";
    SmartOrderType["TakeProfit"] = "TakeProfit";
})(SmartOrderType || (SmartOrderType = {}));
var SmartOrderCode;
(function(SmartOrderCode) {
    SmartOrderCode["AutoBuy"] = "AB";
    SmartOrderCode["StopLoss"] = "SL";
    SmartOrderCode["TakeProfit"] = "TP";
    SmartOrderCode["LimitIfTouched"] = "LIT_SELL";
})(SmartOrderCode || (SmartOrderCode = {}));
var TransactionType;
(function(TransactionType) {
    TransactionType["Buy"] = "Buy";
    TransactionType["Sell"] = "Sell";
})(TransactionType || (TransactionType = {}));
var Expiry;
(function(Expiry) {
    Expiry["GoodForDay"] = "Good For Day";
    Expiry["GoodTillCancelled"] = "Good Till Cancelled";
})(Expiry || (Expiry = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Amended"] = "AMENDED";
    OrderStatus["Withdrawn"] = "WITHDRAWN";
    OrderStatus["Match"] = "MATCH";
    OrderStatus["Ready"] = "READY";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
    OrderStatus["Succeed"] = "SUCCEEDED";
})(OrderStatus || (OrderStatus = {}));
var SplitOrderMethodEnum;
(function(SplitOrderMethodEnum) {
    SplitOrderMethodEnum["UNSPECIFIED"] = "SPLIT_ORDER_METHOD_UNSPECIFIED";
    SplitOrderMethodEnum["EQUAL"] = "SPLIT_ORDER_METHOD_EQUAL";
    SplitOrderMethodEnum["RANDOM"] = "SPLIT_ORDER_METHOD_RANDOM_RANGE";
})(SplitOrderMethodEnum || (SplitOrderMethodEnum = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var AmendSellOrderType;
(function(AmendSellOrderType) {
    AmendSellOrderType["LimitIfTouched"] = "Limit If Touched";
    AmendSellOrderType["StopLoss"] = "Stop Loss";
    AmendSellOrderType["TakeProfit"] = "Take Profit";
})(AmendSellOrderType || (AmendSellOrderType = {}));


/***/ }),

/***/ 20620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q5": function() { return /* binding */ ACCOUNT_TYPE; },
/* harmony export */   "fG": function() { return /* binding */ MODAL_TYPE; },
/* harmony export */   "h$": function() { return /* binding */ LEVERAGE; }
/* harmony export */ });
var ACCOUNT_TYPE;
(function(ACCOUNT_TYPE) {
    ACCOUNT_TYPE["REAL"] = "real";
    ACCOUNT_TYPE["VIRTUAL"] = "virtual";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
var MODAL_TYPE;
(function(MODAL_TYPE) {
    MODAL_TYPE["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    MODAL_TYPE["TRANSACTION"] = "TRANSACTION";
    MODAL_TYPE["AUTO_ORDER"] = "AUTO_ORDER";
    MODAL_TYPE["AUTOBUY_TNC"] = "AUTOBUY_TNC";
    MODAL_TYPE["TRADING_LIMIT_TNC"] = "TRADING_LIMIT_TNC";
    MODAL_TYPE["SPLIT_ORDER_INFO"] = "SPLIT_ORDER_INFO";
    MODAL_TYPE["SPLIT_ORDER_METHOD_INFO"] = "SPLIT_ORDER_METHOD_INFO";
    MODAL_TYPE["ORDER_TYPE"] = "ORDER_TYPE";
    MODAL_TYPE["PREVIEW"] = "PREVIEW";
    MODAL_TYPE["EXCHANGE_FEE"] = "EXCHANGE_FEE";
    MODAL_TYPE["ORDER_PLACED"] = "ORDER_PLACED";
    MODAL_TYPE["SPECIAL_MONITORING"] = "SPECIAL_MONITORING";
    MODAL_TYPE["DAY_TRADE_ONBOARDING"] = "DAY_TRADE_ONBOARDING";
    MODAL_TYPE["DAY_TRADE_TNC"] = "DAY_TRADE_TNC";
    MODAL_TYPE["DAY_TRADE_CONFIRMATION"] = "DAY_TRADE_CONFIRMATION";
    MODAL_TYPE["DAY_TRADE_UNAVAILABLE"] = "DAY_TRADE_UNAVAILABLE";
    MODAL_TYPE["SHARIA_UNAVAILABLE"] = "SHARIA_UNAVAILABLE";
    MODAL_TYPE["SMART_ORDER_PLACED"] = "SMART_ORDER_PLACED";
})(MODAL_TYPE || (MODAL_TYPE = {}));
var LEVERAGE;
(function(LEVERAGE) {
    LEVERAGE["DAY_TRADE"] = "day-trade";
    LEVERAGE["REGULAR"] = "regular";
})(LEVERAGE || (LEVERAGE = {}));


/***/ }),

/***/ 13083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false);
var getSubAccounts = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/list"));
};
var getPurposes = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/purposes"));
};
var getTransferableStocks = function(accountNumber) {
    var query = new URLSearchParams({
        target_account_number: accountNumber
    });
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/transferable-stocks?").concat(query));
};
var getTradingBalance = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/summary"));
};
var postCreatePorto = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/create"), payload);
};
var postSwitchAccount = function(accountNumber) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/auth/account/switch"), {
        account_number: accountNumber
    });
};
var postRenamePorto = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/sub-account/rename"), payload);
};
var postMoveCash = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/intraservice/multi-portfolio/v1/move-cash"), payload);
};
var postMoveStock = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/intraservice/multi-portfolio/v1/move-stock"), payload);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSubAccounts: getSubAccounts,
    getPurposes: getPurposes,
    getTransferableStocks: getTransferableStocks,
    getTradingBalance: getTradingBalance,
    postCreatePorto: postCreatePorto,
    postSwitchAccount: postSwitchAccount,
    postRenamePorto: postRenamePorto,
    postMoveCash: postMoveCash,
    postMoveStock: postMoveStock
});


/***/ }),

/***/ 44590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var SEARCH_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/search");
var SEARCH_RECENT = "".concat(SEARCH_URL, "/recent");
var SEARCH_TYPES = {
    USERS: "users",
    ALL: "all",
    COMPANY: "company",
    EMITEN: "emiten"
};
var getSearchPeople = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return request.get(SEARCH_URL, {
        params: {
            keyword: keyword,
            page: page,
            type: SEARCH_TYPES.USERS
        }
    });
};
var getSearchCompany = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (keyword.length > 1) {
        return request.get(SEARCH_URL, {
            params: {
                keyword: keyword,
                page: page,
                type: SEARCH_TYPES.COMPANY
            }
        });
    }
    return null;
};
var getSearchRecent = function() {
    return request.get(SEARCH_RECENT);
};
var postSearchRecent = function(keyword, target, type) {
    return request.post(SEARCH_RECENT, {
        keyword: keyword,
        target: target,
        type: type
    });
};
var getSearch = function(keyword) {
    if (keyword.length > 1) {
        return request.get(SEARCH_URL, {
            params: {
                keyword: keyword,
                page: 0,
                type: SEARCH_TYPES.ALL
            }
        });
    }
    return null;
};
var getSearchEmiten = function(keyword) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return request.get(SEARCH_URL, {
        params: {
            keyword: keyword,
            page: page,
            type: SEARCH_TYPES.EMITEN,
            country: "ID"
        }
    });
};
// Exports ---------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSearchPeople: getSearchPeople,
    getSearchCompany: getSearchCompany,
    getSearchRecent: getSearchRecent,
    getSearch: getSearch,
    postSearchRecent: postSearchRecent,
    getSearchEmiten: getSearchEmiten
});


/***/ }),

/***/ 65141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4621);
/* harmony import */ var global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9657);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2078);








var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, false, false);
var requestTradingV2 = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, false, false);
var requestSocial = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var getPortfolio = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/list"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/portfolio"));
};
var getConfigFormula = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/formula/v2"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/config/formula"));
};
var getTradingConfig = function() {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/get"));
};
var unlinkTradingAccount = function(brokerKey) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/unlink"), {
        broker: brokerKey
    });
};
var getOrderList = function(gtc) {
    var stock_code = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        if (stock_code) {
            return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/list"), {
                params: {
                    "filter_criteria.stock_code": stock_code
                }
            });
        }
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/list"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/list?gtc=").concat(gtc));
};
var getExerciseList = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/list"));
};
var getExercise = function(stockCode) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise/exercisable?stockCode=").concat(stockCode));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/exerciseable/v2?stockCode=").concat(stockCode));
};
var checkRightTradeable = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise/tradable"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/tradeable"));
};
var checkStockTradable = function(symbol) {
    return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/stock/tradable?stock_codes=").concat(symbol));
};
var getPortfolioDetail = function(symbol) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/portfolio/v2/detail?stock_code=").concat(symbol));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/portfolio/detail?symbol=").concat(symbol));
};
var getCashOnHand = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/balance/cash"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/account/cashonhand"));
};
var getHistory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history"), {
                        params: params
                    }));
                case 2:
                    return _ctx.abrupt("return", requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/history/v4"), params));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHistory(params) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @deprecated we should migrate to the /history or `getHistory` API
 */ var getTransactionHistory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var stockCode, period, _page, page, _limit, limit, queries;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    stockCode = param.stockCode, period = param.period, _page = param.page, page = _page === void 0 ? "1" : _page, _limit = param.limit, limit = _limit === void 0 ? "500" : _limit;
                    if (!(0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
                        _ctx.next = 4;
                        break;
                    }
                    queries = new URLSearchParams({
                        stockCode: stockCode,
                        period: period,
                        page: page,
                        limit: limit
                    });
                    return _ctx.abrupt("return", requestTradingV2("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/history/v3?").concat(queries)));
                case 4:
                    return _ctx.abrupt("return", requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/history/v3"), {
                        stockCode: stockCode,
                        period: period,
                        page: page,
                        limit: limit
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTransactionHistory(_) {
        return _ref.apply(this, arguments);
    };
}();
var tradeBuy = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype, gtc = param.gtc, split_order = param.split_order, platform_order_type = param.platform_order_type;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype,
            is_gtc: gtc === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled,
            time_in_force: "0",
            split_order: split_order,
            platform_order_type: platform_order_type
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/buy"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/buy"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        boardtype: boardtype,
        gtc: global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__/* .expiryId */ .IY[gtc]
    });
};
var dayTradeBuy = function(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, multiplier = param.multiplier;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/buy"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        symbol: symbol,
        price: price,
        shares: shares,
        multiplier: multiplier
    });
};
var tradeSell = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype, _gtc = param.gtc, gtc = _gtc === void 0 ? global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodForDay */ .ZM.GoodForDay : _gtc, split_order = param.split_order, platform_order_type = param.platform_order_type;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype,
            is_gtc: gtc === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled,
            time_in_force: "0",
            split_order: split_order,
            platform_order_type: platform_order_type
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/sell"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/sell"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        boardtype: boardtype,
        gtc: global_Securities_constants_transactionForm__WEBPACK_IMPORTED_MODULE_5__/* .expiryId */ .IY[gtc]
    });
};
var dayTradeSell = function(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/sell"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        symbol: symbol,
        price: price,
        shares: shares
    });
};
/**
 * @deprecated use `bulkTradeAmend` instead
 */ var tradeAmend = function(param) {
    var orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, orderid = param.orderid, _boardtype = param.boardtype, boardtype = _boardtype === void 0 ? "RG" : _boardtype;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            order_id: orderid,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
            symbol: symbol,
            price: price,
            shares: shares,
            board_type: boardtype
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/amend"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/amend"), {
        orderkey: orderkey,
        symbol: symbol,
        price: price,
        shares: shares,
        orderid: orderid
    });
};
var bulkTradeAmend = function(orders) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/amend/bulk"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        amend_request: orders
    });
};
var dayTradeAmend = function(param) {
    var orderid = param.orderid, price = param.price, shares = param.shares, multiplier = param.multiplier;
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/amend"), {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        multiplier: multiplier,
        price: price,
        shares: shares,
        order_id: orderid
    });
};
var tradeCancel = function(data) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        var body = {
            order_id: data.orderid,
            ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)()
        };
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/v2/cancel"), body);
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/order/cancel"), data);
};
var dayTradeCancel = function(orderKey) {
    var data = {
        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateUiRef */ .TW)(),
        order_id: orderKey
    };
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/order/day-trade/v1/cancel"), data);
};
var postRequestExercise = function(param) {
    var orderKey = param.orderKey, stockCode = param.stockCode, shares = param.shares;
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/exercise"), {
            stock_code: stockCode,
            shares: shares
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/exercise/request"), {
        stock_code: stockCode,
        shares: shares,
        order_key: orderKey
    });
};
var logout = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/logout"));
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/logout"));
};
var getTradingProfile = function() {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/account"));
    }
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/account"));
};
var getTradingProfilePersonal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", requestSocial.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_SECURITIES_GENERAL_URL */ .kg, "/account/personal")));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTradingProfilePersonal() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Validate PIN
 * @param {string} pin - user input
 * @param {string} type - string
 * @return {APIResponse}
 */ var checkPin = function(pin, type) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/validate"), {
            pin: pin,
            purpose: type
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/pin/validate"), {
        pin: pin,
        type: type
    });
};
/**
 * Change PIN
 * @param {string} pin - user input
 * @param {string} type - string
 * @return {APIResponse}
 */ var changePin = function(old_pin, new_pin, token) {
    if ((0,features_securities_utils__WEBPACK_IMPORTED_MODULE_4__/* .isRedirectToNewCore */ .JI)()) {
        return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/pin/change"), {
            old_pin: old_pin,
            new_pin: new_pin,
            token: token
        });
    }
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL */ .Cb, "/auth/changepin"), {
        old_pin: old_pin,
        new_pin: new_pin,
        token: token
    });
};
var checkSubAccountDayTrade = function(type) {
    return requestTradingV2.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/account/sub-account/detail?type=").concat(type));
};
var deleteTrailingStop = function(orderId) {
    return requestTradingV2.delete("/smart-order/trailing-stop/v1/order/".concat(orderId));
};
var deleteStopOrder = function(orderId) {
    return requestTradingV2.delete("/smart-order/stop-order/v1/order/".concat(orderId));
};
var deleteBracketOrder = function(orderId) {
    return requestTradingV2.delete("/smart-order/bracket-order/v1/order/".concat(orderId));
};
var newChangePin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/new"), {
        pin: pin,
        token: token
    });
};
var confirmChangePin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/confirm"), {
        pin: pin,
        token: token
    });
};
var validateIdentity = function(identity) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/validate"), {
        identity: identity
    });
};
var newResetPin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/new"), {
        pin: pin,
        token: token
    });
};
var confirmResetPin = function(pin, token) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/confirm"), {
        pin: pin,
        token: token
    });
};
var sendChangeOTP = function(token, channel) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/otp/send"), {
        token: token,
        channel: channel
    });
};
var verifyChangeOTP = function(token, otp) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/change/otp/verify"), {
        token: token,
        otp: otp
    });
};
var sendResetPinOTP = function(token, channel) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/otp/send"), {
        token: token,
        channel: channel
    });
};
var verifyResetPinOTP = function(token, otp) {
    return requestTradingV2.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_TRADING_URL_V2 */ .cu, "/auth/v2/pin/reset/otp/verify"), {
        token: token,
        otp: otp
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getConfigFormula: getConfigFormula,
    getPortfolio: getPortfolio,
    getOrderList: getOrderList,
    getExerciseList: getExerciseList,
    // trade
    getExercise: getExercise,
    getPortfolioDetail: getPortfolioDetail,
    getCashOnHand: getCashOnHand,
    tradeBuy: tradeBuy,
    tradeSell: tradeSell,
    tradeAmend: tradeAmend,
    bulkTradeAmend: bulkTradeAmend,
    tradeCancel: tradeCancel,
    postRequestExercise: postRequestExercise,
    // day trade
    dayTradeBuy: dayTradeBuy,
    dayTradeSell: dayTradeSell,
    dayTradeAmend: dayTradeAmend,
    dayTradeCancel: dayTradeCancel,
    getTradingConfig: getTradingConfig,
    unlinkTradingAccount: unlinkTradingAccount,
    logout: logout,
    getHistory: getHistory,
    getTransactionHistory: getTransactionHistory,
    getTradingProfile: getTradingProfile,
    getTradingProfilePersonal: getTradingProfilePersonal,
    checkPin: checkPin,
    changePin: changePin,
    newChangePin: newChangePin,
    confirmChangePin: confirmChangePin,
    sendChangeOTP: sendChangeOTP,
    verifyChangeOTP: verifyChangeOTP,
    validateIdentity: validateIdentity,
    newResetPin: newResetPin,
    confirmResetPin: confirmResetPin,
    sendResetPinOTP: sendResetPinOTP,
    verifyResetPinOTP: verifyResetPinOTP,
    checkRightTradeable: checkRightTradeable,
    checkStockTradable: checkStockTradable,
    checkSubAccountDayTrade: checkSubAccountDayTrade,
    deleteTrailingStop: deleteTrailingStop,
    deleteStopOrder: deleteStopOrder,
    deleteBracketOrder: deleteBracketOrder
});


/***/ }),

/***/ 66679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var getWSTradingKey = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/auth/websocket/key"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getWSKey: getWSTradingKey,
    getWSTradingKey: getWSTradingKey
});


/***/ }),

/***/ 34385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38597);
/* harmony import */ var lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13083);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65906);
/* harmony import */ var features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3683);
/* harmony import */ var config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68481);










var UNAUTHORIZED = 401;
var defaultInitialState = {
    isLoading: false,
    error: ""
};
var subAccountsInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        sub_accounts: [],
        can_create_new_sub_account: false,
        can_not_create_new_sub_account_reason: undefined
    }
});
var subAccountsPurposeInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        purposes: []
    }
});
var withDrawableInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        balance: {
            withdrawable: 0,
            transaction: 0,
            pending: 0,
            leverage_liability: 0,
            net_withdrawable: 0
        },
        settlement_schedules: [],
        legends: []
    }
});
var tradingBalanceInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        balance: 0,
        equity: 0
    }
});
var portfoliosStockInitialState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, defaultInitialState), {
    data: {
        stocks: []
    }
});
var createPortfolioFormInitialState = {
    portfolio_name: "",
    tnc: {
        feature_id: "",
        version: 0
    },
    purpose: ""
};
var renamePortfolioFormInitialState = {
    target_account_number: "",
    new_portfolio_name: ""
};
var moveCashFormInitialState = {
    from_acc_no: "",
    to_acc_no: "",
    amount: 0
};
var moveStockFormInitialState = {
    from_acc_no: "",
    to_acc_no: "",
    stocks_data: []
};
var initialState = {
    activeAccount: "",
    subAccountsData: subAccountsInitialState,
    subAccountsPurposeData: subAccountsPurposeInitialState,
    withDrawableData: withDrawableInitialState,
    transferableStocks: portfoliosStockInitialState,
    tradingBalanceData: tradingBalanceInitialState,
    createPortfolioForm: createPortfolioFormInitialState,
    renamePortfolioForm: renamePortfolioFormInitialState,
    moveCashForm: moveCashFormInitialState,
    moveStockForm: moveStockFormInitialState
};
var useMultiPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_7__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_7__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        getSubAccounts: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsData;
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSubAccounts */ .Z.getSubAccounts();
                    case 6:
                        data = _ctx.sent.data;
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: data.data,
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        if (_ctx.t0.status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        })),
        getPurposes: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data, status;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsPurposeData;
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPurposes */ .Z.getPurposes();
                    case 6:
                        data = _ctx.sent.data;
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: data.data,
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            subAccountsPurposeData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, subAccountsPurposeInitialState), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                        if (status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        })),
        getWithdrawable: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(scope, accountNumber) {
                var ref, currentData, params, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.withDrawableData;
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    isLoading: true
                                })
                            });
                            _ctx.prev = 3;
                            params = {
                                scope: scope,
                                accountNumber: accountNumber
                            };
                            _ctx.next = 7;
                            return lib_api_securities__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTradingBalanceDetail */ .Z.getTradingBalanceDetail(params);
                        case 7:
                            data = _ctx.sent.data;
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    data: data.data,
                                    error: "",
                                    isLoading: false
                                })
                            });
                            return _ctx.abrupt("return", data.data);
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                withDrawableData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, withDrawableInitialState), {
                                    error: _ctx.t0,
                                    isLoading: false
                                })
                            });
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        12
                    ]
                ]);
            }));
            return function(scope, accountNumber) {
                return _ref.apply(this, arguments);
            };
        }(),
        getTransferableStocks: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(account) {
                var ref, currentData, data, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.transferableStocks;
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    isLoading: true
                                })
                            });
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTransferableStocks */ .Z.getTransferableStocks(account);
                        case 6:
                            data = _ctx.sent.data;
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                    data: data.data,
                                    error: "",
                                    isLoading: false
                                })
                            });
                            return _ctx.abrupt("return", data.data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                transferableStocks: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, portfoliosStockInitialState), {
                                    error: _ctx.t0,
                                    isLoading: false
                                })
                            });
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(account) {
                return _ref.apply(this, arguments);
            };
        }(),
        getTradingBalance: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, currentData, data, ref1, summary, status;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentData = (ref = get()) === null || ref === void 0 ? void 0 : ref.tradingBalanceData;
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                isLoading: true
                            })
                        });
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTradingBalance */ .Z.getTradingBalance();
                    case 6:
                        data = _ctx.sent.data;
                        ref1 = data.data || {}, summary = ref1.aggregated_portfolio_summary;
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentData), {
                                data: {
                                    balance: summary.trading.balance,
                                    equity: summary.equity
                                },
                                error: "",
                                isLoading: false
                            })
                        });
                        return _ctx.abrupt("return", data.data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](3);
                        set({
                            tradingBalanceData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tradingBalanceInitialState), {
                                error: _ctx.t0,
                                isLoading: false
                            })
                        });
                        status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                        if (status === UNAUTHORIZED) {
                            features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                        }
                        return _ctx.abrupt("return", _ctx.t0);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    12
                ]
            ]);
        })),
        resetTransferableStocks: function() {
            return set({
                transferableStocks: portfoliosStockInitialState
            });
        },
        resetWithdrawable: function() {
            return set({
                withDrawableData: withDrawableInitialState
            });
        },
        postCreatePorto: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var ref, ref1, data, udpatedSubAccounts, newSubAccountsLength, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postCreatePorto */ .Z.postCreatePorto(payload);
                        case 4:
                            data = _ctx.sent.data;
                            udpatedSubAccounts = data.data.sub_accounts;
                            newSubAccountsLength = udpatedSubAccounts.length;
                            set({
                                subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsData), {
                                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.subAccountsData.data), {
                                        sub_accounts: udpatedSubAccounts
                                    }), {
                                        can_create_new_sub_account: newSubAccountsLength < 4
                                    })
                                })
                            });
                            return _ctx.abrupt("return", true);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postRenamePorto: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var ref, ref1, data, udpatedSubAccounts, status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postRenamePorto */ .Z.postRenamePorto(payload);
                        case 4:
                            data = _ctx.sent.data;
                            udpatedSubAccounts = data.data.sub_accounts;
                            set({
                                subAccountsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref = get()) === null || ref === void 0 ? void 0 : ref.subAccountsData), {
                                    data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.subAccountsData.data), {
                                        sub_accounts: udpatedSubAccounts
                                    })
                                })
                            });
                            return _ctx.abrupt("return", true);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postMoveCash: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postMoveCash */ .Z.postMoveCash(payload);
                        case 3:
                            return _ctx.abrupt("return", true);
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postMoveStock: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
                var status;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return lib_api_multi_porto__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postMoveStock */ .Z.postMoveStock(payload);
                        case 3:
                            return _ctx.abrupt("return", true);
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            status = (0,config_requestTrading_utils__WEBPACK_IMPORTED_MODULE_9__/* .getErrorConfig */ .v)(_ctx.t0).status;
                            if (status === UNAUTHORIZED) {
                                features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().closeModal();
                            }
                            return _ctx.abrupt("return", _ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        setActiveAccount: function(account) {
            return set({
                activeAccount: account
            });
        },
        setPortfolioForm: function(form) {
            return set({
                createPortfolioForm: form
            });
        },
        setRenamePortfolioForm: function(form) {
            return set({
                renamePortfolioForm: form
            });
        },
        setMoveCashForm: function(form) {
            return set({
                moveCashForm: form
            });
        },
        setMoveStockForm: function(form) {
            return set({
                moveStockForm: form
            });
        },
        resetMoveCashForm: function() {
            return set({
                moveCashForm: moveCashFormInitialState
            });
        },
        resetMoveStockForm: function() {
            return set({
                moveStockForm: moveStockFormInitialState
            });
        },
        resetState: function() {
            set(initialState);
        }
    });
}, {
    name: "multi-portfolio-storage",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            subAccountsData: state.subAccountsData,
            activeAccount: state.activeAccount,
            subAccountsPurposeData: state.subAccountsPurposeData,
            tradingBalanceData: state.tradingBalanceData
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (useMultiPortfolioStore);


/***/ }),

/***/ 48028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ clevertapProfilingUser; },
/* harmony export */   "Lq": function() { return /* binding */ clevertapEvent; },
/* harmony export */   "QU": function() { return /* binding */ clevertapInitProfileQueue; },
/* harmony export */   "Vg": function() { return /* binding */ clearClevertapState; },
/* harmony export */   "nh": function() { return /* binding */ academyUserProfiling; },
/* harmony export */   "ze": function() { return /* binding */ academyEventAnalytic; }
/* harmony export */ });
/* unused harmony export clevertapProfilingUserEligible */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* eslint-disable no-underscore-dangle */ 


var clevertapProfileQueue = [];
function clevertapInitProfileQueue() {
    clevertapProfileQueue.forEach(function(instance) {
        return instance();
    });
    clevertapProfileQueue = [];
}
/**
 * this function will executes clevertap analytic based on isInitProfile
 * @param {boolean} isInitProfile
 * @param {string} username
 * @param {boolean} isVirtualTrading
 * @param {boolean} isTopUser
 * @param {boolean} isVerifiedUser
 * @param {boolean} isStockbitPro
 * @param {Date} registrationStartDate
 * @param {string} profilePictureUrl
 * @param {boolean} isSinarmasSecuritas
 * @param {string} email
 * @param {isStockbitSecuritas} isStockbitSecuritas
 * @return {void} no return after execute this function
 */ function clevertapProfilingUser(param) {
    var isInitProfile = param.isInitProfile, identity = param.identity, isVirtualTrading = param.isVirtualTrading, isTopUser = param.isTopUser, isVerifiedUser = param.isVerifiedUser, isStockbitPro = param.isStockbitPro, registrationStartDate = param.registrationStartDate, profilePictureUrl = param.profilePictureUrl, isSinarmasSecuritas = param.isSinarmasSecuritas, email = param.email, isStockbitSecuritas = param.isStockbitSecuritas, _isEmitenUser = param.isEmitenUser, isEmitenUser = _isEmitenUser === void 0 ? false : _isEmitenUser;
    // Track if username is empty
    if (!identity) {
        (0,_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
            place: "src/utils/clevertap.ts",
            event: "clevertapProfilingUser",
            eventParam: {
                profile: {
                    identity: identity,
                    email: email
                }
            }
        });
    }
    var clevertapProfilingData = {
        Name: identity,
        Identity: identity,
        "Is Virtual Trading": isVirtualTrading !== undefined ? isVirtualTrading : undefined,
        "Is Top User": isTopUser !== undefined ? isTopUser : undefined,
        "Is Verified User": isVerifiedUser !== undefined ? isVerifiedUser : undefined,
        "Is Stockbit Pro": isStockbitPro !== undefined ? isStockbitPro : undefined,
        "Registration Start Date": registrationStartDate !== undefined ? registrationStartDate : undefined,
        Photo: profilePictureUrl !== undefined ? "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(profilePictureUrl) : undefined,
        "Is Sinarmas Sekuritas": isSinarmasSecuritas !== undefined ? isSinarmasSecuritas : undefined,
        Email: email !== undefined ? email : undefined,
        "Is Stockbit Sekuritas": isStockbitSecuritas !== undefined ? isStockbitSecuritas : undefined,
        "Is Emiten User": isEmitenUser !== undefined ? isEmitenUser : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingData).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingData[key] !== undefined) {
            _acc[key] = clevertapProfilingData[key];
        }
        return _acc;
    }, {});
    var handleInitProfile = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.onUserLogin.push({
            Site: payload
        });
    };
    var handleProfilePush = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
            Site: payload
        });
    };
    var initProfileFunction = isInitProfile ? handleInitProfile : handleProfilePush;
    if (!window.clevertap) {
        clevertapProfileQueue.push(initProfileFunction);
        return;
    }
    initProfileFunction();
}
function clevertapEvent(eventName) {
    var eventObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Object.keys(eventObject).length > 0) {
        var // execute this impression if impression has additional attributes
        ref, ref1;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.push(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventObject));
    } else {
        var ref2, ref3;
        (ref2 = window.clevertap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.push(eventName);
    }
}
function clevertapProfilingUserEligible(param) {
    var followers = param.followers, following = param.following, posts = param.posts, isMuted = param.isMuted, isVerifiedEligible = param.isVerifiedEligible;
    var clevertapProfilingDataEligible = {
        Followers: followers !== undefined ? followers : undefined,
        Following: following !== undefined ? following : undefined,
        Posts: posts !== undefined ? posts : undefined,
        "is Muted": isMuted !== undefined ? isMuted : undefined,
        "Is Verified Badge Eligible": isVerifiedEligible !== undefined ? isVerifiedEligible : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingDataEligible).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingDataEligible[key] !== undefined) {
            _acc[key] = clevertapProfilingDataEligible[key];
        }
        return _acc;
    }, {});
    window.clevertap.profile.push({
        Site: payload
    });
}
function academyEventAnalytic(eventName, parameter) {
    if (!eventName) {
        return;
    }
    clevertapEvent(eventName, parameter);
}
function academyUserProfiling() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var ref;
    if (!data && !data.parameter) {
        return;
    }
    // filter to remove undefined value of object
    // eslint-disable-next-line array-callback-return
    var payload = Object.keys(data.parameter).reduce(function(acc, key) {
        var currentAcc = acc;
        if (data[key] !== undefined) {
            currentAcc[key] = data[key];
            return currentAcc;
        }
        return null;
    }, {});
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
        Site: payload
    });
}
function clearClevertapState() {
    var ref, ref1;
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.logout();
    (ref1 = window.clevertap) === null || ref1 === void 0 ? void 0 : ref1.clear();
}


/***/ }),

/***/ 65458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ onReceiveMessage; },
/* harmony export */   "ZN": function() { return /* binding */ toggle; },
/* harmony export */   "kG": function() { return /* binding */ setNewSession; },
/* harmony export */   "l4": function() { return /* binding */ onLoaded; },
/* harmony export */   "lA": function() { return /* binding */ handleClickSupport; },
/* harmony export */   "te": function() { return /* binding */ destroyCurrentSession; },
/* harmony export */   "zp": function() { return /* binding */ onOpen; }
/* harmony export */ });
/* unused harmony exports crispReady, isCrispReady, createNewSession, resetSession, hide, safe, getSessionId, isChatOpened, isChatClosed */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36661);
/* harmony import */ var _clevertap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48028);




function crispReady(cb) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var $crisp = window.$crisp;
    if ($crisp && timeout < 1) {
        return cb($crisp);
    }
    setTimeout(function() {
        if ($crisp) {
            cb($crisp);
        } else {
            crispReady(cb, timeout);
        }
    }, timeout);
    return null;
}
var isCrispReady = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && !!window.$crisp;
};
function setNewSession(userData) {
    if (!isCrispReady()) return;
    // resetting session is necessary due to crisp autoloaded
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.session.reset */ .fv.session.reset();
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    if (!userData) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setNickname */ .fv.user.setNickname(userData.username);
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setEmail */ .fv.user.setEmail(userData.email);
    if (userData === null || userData === void 0 ? void 0 : userData.phone) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setPhone */ .fv.user.setPhone(userData.phone);
    }
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.user.setAvatar */ .fv.user.setAvatar("".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(userData.avatar));
}
function createNewSession(param) {
    var email = param.email, fullname = param.fullname, id = param.id;
    window.CRISP_TOKEN_ID = id;
    setNewSession({
        email: email,
        fullname: fullname
    });
}
function destroyCurrentSession() {
    if (false) {}
    delete window.CRISP_TOKEN_ID;
    crispReady(function($crisp) {
        if ($crisp && $crisp.push) $crisp.push([
            "do",
            "session:reset"
        ]);
    }, 0);
}
function resetSession() {
    if (!isCrispReady()) return;
    Crisp.session.reset();
}
function hide() {
    if (!isCrispReady()) return;
    Crisp.chat.hide();
}
function toggle() {
    if (!isCrispReady()) return;
    var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
    if (isOpened) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    } else {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.show */ .fv.chat.show();
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.open */ .fv.chat.open();
    }
}
function onLoaded() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.session.onLoaded */ .fv.session.onLoaded(function() {
        var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
        if (!isOpened) {
            crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
        }
    });
}
function onOpen() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.onChatOpened */ .fv.chat.onChatOpened(function() {
        var unreadCount = document.querySelector(".intercom-unread-count");
        unreadCount.classList.remove("active");
    });
}
function safe() {
    if (!isCrispReady()) return;
    Crisp.setSafeMode(true);
}
function onReceiveMessage() {
    if (!isCrispReady()) return;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.message.onMessageReceived */ .fv.message.onMessageReceived(function() {
        var unreadCount = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.unreadCount */ .fv.chat.unreadCount();
        var unreadCountEl = document.querySelector(".intercom-unread-count");
        if (unreadCount > 0) {
            unreadCountEl.classList.add("active");
        }
    });
}
function getSessionId() {
    if (!isCrispReady()) return null;
    var sessionId = Crisp.session.getIdentifier();
    return sessionId;
}
function isChatOpened() {
    if (!isCrispReady()) return false;
    return Crisp.chat.isChatOpened();
}
function isChatClosed() {
    if (!isCrispReady()) return false;
    var isOpened = Crisp.chat.isChatOpened();
    return !isOpened;
}
var handleClickSupport = function() {
    if (!isCrispReady()) return;
    var isOpened = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.isChatOpened */ .fv.chat.isChatOpened();
    if (isOpened) {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.close */ .fv.chat.close();
    } else {
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.show */ .fv.chat.show();
        crisp_sdk_web__WEBPACK_IMPORTED_MODULE_2__/* .Crisp.chat.open */ .fv.chat.open();
        (0,_clevertap__WEBPACK_IMPORTED_MODULE_3__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CLEVERTAP_EVENT_NAME.SIDE_MENU */ .dR.SIDE_MENU, {
            Action: "support"
        });
    }
};


/***/ })

}]);